import * as Handlebars from "handlebars";
import "../../common/common-helpers";

Handlebars.registerHelper('gt', function( a, b, options){
    return (a > b) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('getComponentImageSrc', function(url, index) {
    return `${url}?action=getcomponentimage&componentid=${index}`;
});